import { createSelector } from '@ngrx/store';

import { HotelDetailModuleState } from '@hotels/hotel-detail/store/state/hotel-detail-module.state';
import { hotelDetailRootSelector } from '@hotels/hotel-detail/store/selectors/hotel-detail-root.selector';
import { HotelSearchState } from '@hotels/hotel-detail/store/reducers/hotel-search-detail.reducer';

export const getHotelSearchState = createSelector(
  hotelDetailRootSelector,
  (state: HotelDetailModuleState) => state.searchDetail
);

export const hotelSearchDetailSelector = createSelector(getHotelSearchState, (state: HotelSearchState) => state);
